import { dispatchTrackingEvent } from '@context/tracking/utils';
import { isDesktop } from '@utils/helpers';

interface TrackLoyaltyParams {
  timing: number;
  name: 'loyalty_anonymous' | 'loyalty_logged_in';
}

export const trackLoyalty = ({ timing, name }: TrackLoyaltyParams) => {
  dispatchTrackingEvent({
    event: 'element_click',
    _clear: true,
    element: {
      timing,
      interaction: 'open',
      name,
      type: 'loyalty_pd',
    },
  });
};

export const trackOpenDrawer = ({ timing }: { timing: number }) => {
  dispatchTrackingEvent({
    event: 'subpage_view',
    subpage: {
      name: 'loyalty_intro',
      type: isDesktop() ? 'modal' : 'drawer',
      timing,
      action: '',
      unified_name: '',
      interaction: '',
    },
    _clear: true,
  });
};

export const trackCloseDrawerOrModal = ({
  isOutsideClick,
}: {
  isOutsideClick: boolean;
}) => {
  dispatchTrackingEvent({
    event: 'subpage_close',
    name: 'loyalty_intro',
    interaction: isOutsideClick ? 'click_outside' : 'close_x',
    subpage: undefined,
    _clear: true,
  });
};

export const trackLoyaltyJoin = (
  productCode: string,
  type: 'Enter' | 'Subscribe'
) => {
  dispatchTrackingEvent({
    event: 'loyalty_join',
    loyalty: {
      page_id: `product-${productCode}`,
      type,
    },
  });
};
